import { actionTypes } from "./actions";

const initialState = {
    uploading: false,
    submissionUpload: 0,
    total: 0,
    uploaded: 0,
    totalAssetToSync: 0,
    syncProgressAssets: 0,
    linkedAudits: [],
    auditSignature: {
        dealerContactName: "",
        dealerContactEmail: "",
        dealerContactRole: "",
        dealerContactComment: "",
        dealerContactSignature: "",
        dealerContactSignatureDate: "",
        dealerLatitude: null,
        dealerLongitude: null,
        auditorComment: "",
        auditorSignature: "",
        auditorSignatureDate: "",
        auditorLatitude: null,
        auditorLongitude: null,
    },
};

export default function (state = initialState, action) {
    switch (action.type) {
        case actionTypes.AUDIT_UPLOAD_CLEAR: {
            return initialState;
        }
        case actionTypes.AUDIT_UPLOAD_STATUS_SET: {
            const { status } = action.payload;
            return status;
        }
        case actionTypes.AUDIT_PARTIAL_UPLOAD_STATUS_UPLOADED: {
            const { uploaded, uploading } = action.payload;
            return {
                ...state,
                uploaded: state.uploaded + uploaded,
                uploading: uploading,
            };
        }
        case actionTypes.AUDIT_PARTIAL_UPLOAD_ASSET_STATUS: {
            const { totalAssetToSync, syncProgressAssets, uploaded } =
                action.payload;
            return {
                ...state,
                totalAssetToSync,
                syncProgressAssets,
                uploaded,
            };
        }
        case actionTypes.AUDIT_UPLOAD_STATUS_UPLOADED: {
            const { submissionUpload } = action.payload;
            return {
                ...state,
                submissionUpload: state.submissionUpload + submissionUpload,
            };
        }
        case actionTypes.ASSET_LINKED_STORE_AUDITID: {
            const { auditId } = action.payload;
            return { ...state, linkedAudits: auditId };
        }

        case actionTypes.AUDIT_UPLOAD_UPDATE_SUCCESS: {
            const { auditUpload } = action.payload;
            return { ...state, ...auditUpload };
        }

        case actionTypes.AUDIT_UPLOAD_CLEAR_SIGNATURE_SUCCESS: {
            const { updatedAuditUpload } = action.payload;
            return { ...updatedAuditUpload };
        }

        default: {
            return state;
        }
    }
}
